module.exports = __webpack_public_path__ + "files/9a3d2dbe750cdbbad535114bbc9677c9.png";